import { useState } from "react";
import { FiSend } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { getAdminData } from "../../../Utils/role";
import { closeModal } from "../../../redux/features/modalSlice";
import { successToast, errorToast } from "../../../Utils/toast";
import { VendorEnquiry } from "../../../redux/services/EnquriesService/enquries.Services";
// import subscriptionPlans from "../../wallet Managment/SubscriptionPlans";

function AddVendorEnquiry({ data }) {
  const dispatch = useDispatch();
  const vendor = getAdminData();

  const [form, setForm] = useState({
    name: vendor?.name || "",
    email: vendor?.email || "",
    phone: vendor?.phone || vendor?.mobile || "",
    message: "",
  });

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const handlePlanSelect = (planId) => {
    setSelectedPlan(planId);
    if (errors.plan) {
      setErrors((prev) => ({ ...prev, plan: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};

    // if (!selectedPlan) {
    //   newErrors.plan = "Please select a subscription plan";
    // }
    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!form.phone.trim()) {
      newErrors.phone = "Mobile number is required";
    } else if (!/^\d{10}$/.test(form.phone.replace(/\D/g, ""))) {
      newErrors.phone = "Mobile must be 10 digits";
    }
    if (!form.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
      setForm((prev) => ({ ...prev, [name]: digitsOnly }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setSubmitting(true);

      // const chosenPlan = subscriptionPlans.find(
      //   (p) => p.id === selectedPlan
      // );
      const moduleId =
        data?.module_id;

      const moduleName =
        data?.module_name ??
        data?.moduleName ??
        data?.module?.name ??
        data?.name

      const payload = {
        name: form.name.trim(),
        email: form.email.trim() || "",
        phone: form.phone.replace(/\D/g, ""),
        message: form.message.trim(),
        vendorId: vendor?.user_id || vendor?.id || null,
        module_id: moduleId,
        module_name: moduleName,
        // planId: chosenPlan?.id || null,
        // planName: chosenPlan?.name || "",
      };
      console.log("Enquiry payload:", payload);
      const response = await VendorEnquiry(payload);

      if (
        response?.success ||
        response?.status === 200 ||
        response?.status === 201
      ) {
        successToast(response?.message || "Inquiry submitted successfully!");
        dispatch(closeModal());
      } else {
        errorToast(response?.message || "Failed to submit inquiry");
      }
    } catch (err) {
      console.error("Error:", err);
      const errMsg =
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong. Please try again.";
      errorToast(errMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="vendor-enquiry-form">
      <form onSubmit={handleSubmit} noValidate>
        {/* <subscriptionPlans.Selector
          selectedPlan={selectedPlan}
          onSelect={handlePlanSelect}
          error={errors.plan}
        /> */}

        <div className="row">
          <div className="col-md-6">
            <div className="edit-form-group">
              <label className="form-label">
                Full Name <span className="required-star">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter your name"
                className={`form-control ${errors.name ? "input-error" : ""}`}
              />
              {errors.name && (
                <span className="error-text">{errors.name}</span>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="edit-form-group">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="form-control"
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="edit-form-group">
              <label className="form-label">
                Phone <span className="required-star">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Mobile number"
                maxLength={10}
                inputMode="numeric"
                className={`form-control ${errors.phone ? "input-error" : ""}`}
              />
              {errors.phone && (
                <span className="error-text">{errors.phone}</span>
              )}
            </div>
          </div>

          <div className="col-md-12">
            <div className="edit-form-group">
              <label className="form-label">
                Message <span className="required-star">*</span>
              </label>
              <textarea
                name="message"
                rows="3"
                value={form.message}
                onChange={handleChange}
                placeholder="Any specific requirement?"
                className={`form-control ${errors.message ? "input-error" : ""}`}
              />
              {errors.message && (
                <span className="error-text">{errors.message}</span>
              )}
            </div>
          </div>

          <div className="col-md-12">
            <div className="modal-btn-group">
              <button
                type="button"
                className="cancel-btn"
                onClick={() => dispatch(closeModal())}
                disabled={submitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="save-btn"
                disabled={submitting}
              >
                {submitting ? (
                  "Submitting..."
                ) : (
                  <>
                    <FiSend /> Submit
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddVendorEnquiry;